import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Avenue from "./views/Avenue.vue";
import Path from "./views/Path.vue";
import Catalog from "./views/Catalog.vue";
import CatalogGroup from "./views/CatalogGroup.vue";
import Cart from "./views/Cart.vue";
import Config from "./views/Config.vue";
import DisplayOrder from "./views/DisplayOrder.vue";

Vue.use(Router);

var router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/Login",
      component: Login
    },
    {
      path: "/Manufacturers/:manufacturerId/Avenue",
      component: Avenue,
      children: [
        {
          path: "Path",
          component: Path
        },
        {
          path: "Catalog",
          component: Catalog
        },
        {
          path: "Groups/:pageNumber",
          component: CatalogGroup
        },
        {
          path: "Cart",
          component: Cart
        },
        {
          path: "Config/:itemId",
          component: Config
        },
        {
          path: "DisplayOrder/:orderId",
          component: DisplayOrder
        }
      ]
    }
  ]
});

// Global Navigation Guard
router.beforeEach((to, from, next) => {
  var loggedIn = localStorage.getItem("token");
  if (to.path != "/Login" && !loggedIn) {
    next('/Login');
  }
  else {
    next();
  }
});

export default router;
